// TS twin of iOS `AssemblyCode` value object.
// Newtype over string; trim and reject empty input.

export interface AssemblyCode {
  readonly value: string
}

export function assemblyCode(raw: string | null | undefined): AssemblyCode | null {
  if (raw == null) return null
  const trimmed = raw.trim()
  if (trimmed.length === 0) return null
  return { value: trimmed }
}
